var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import WidgetSelectorStudio from "@/components/widgets/selector/widgetSelectorStudio";
import WidgetDisplay from "@/components/widgets/widgetDisplay";
import { useAppSelector } from "@/hooks/store";
import { useGetModuleBuilderLayoutListWidgetsQuery, useSaveModuleBuilderLayoutListWidgetMutation, } from "@/store/api";
import { removeModuleListWidgets } from "@/store/layoutSlice";
import { LoaderImage } from "@/utils/loader";
import { faPencil, faSave, faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
export default function AddWidget(_a) {
    var _this = this;
    var _b;
    var module = _a.module;
    var uuidv4 = require("uuid").v4;
    var t = useTranslation(["common"]).t;
    var _c = useParams(), packagesName = _c.packagesName, moduleName = _c.moduleName, type = _c.type, action = _c.action, fieldName = _c.fieldName, actionWidget = _c.actionWidget;
    var _d = useSaveModuleBuilderLayoutListWidgetMutation(), saveModuleBuilderLayoutListWidget = _d[0], _e = _d[1], saveWidget = _e.data, isLoadingSave = _e.isLoading;
    var id = uuidv4();
    var initalState = {};
    var _f = useState({
        id: "",
        type: "",
        payload: {},
        mode: "add",
        slot: null, // "add" or "edit"
    }), selector = _f[0], setSelector = _f[1];
    //const selector =
    var widgetModuelList = useAppSelector(function (state) { return state.layout.moduleList; });
    var widgetModuleListFromLayoutState = widgetModuelList === null || widgetModuelList === void 0 ? void 0 : widgetModuelList.find(function (item) { return item[module]; });
    var _g = useGetModuleBuilderLayoutListWidgetsQuery({
        moduleName: moduleName,
        params: {
            layout: fieldName,
        },
    }), list_widgetModule = _g.data, refetch = _g.refetch, isLoadList = _g.isLoading;
    var _h = useState([]), widgetModuleListFromLayout = _h[0], setWidgetModuleListFromLayout = _h[1];
    var getModuleListWidgets = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if ((_a = list_widgetModule === null || list_widgetModule === void 0 ? void 0 : list_widgetModule.data) === null || _a === void 0 ? void 0 : _a.listwidgets) {
                setWidgetModuleListFromLayout((_b = list_widgetModule === null || list_widgetModule === void 0 ? void 0 : list_widgetModule.data) === null || _b === void 0 ? void 0 : _b.listwidgets);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        refetch();
        getModuleListWidgets();
    }, [list_widgetModule]);
    var _j = useState(false), isDeleting = _j[0], setIsDeleting = _j[1];
    var dispatch = useDispatch();
    var handleRemoveWidget = function (id) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsDeleting(true);
            setWidgetModuleListFromLayout(function (prevList) {
                return prevList.filter(function (widget) { return widget.id !== id; });
            });
            dispatch(removeModuleListWidgets([]));
            setIsDeleting(false);
            return [2 /*return*/];
        });
    }); };
    var handleEditWidget = function (widget) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setSelector({
                id: widget.id,
                type: widget.type,
                payload: __assign(__assign({}, widget.payload), { onEditDone: function () {
                        setSelector({
                            id: "",
                            type: "widget/selector",
                            payload: {},
                            mode: "add",
                            slot: null,
                        });
                    } }),
                mode: "edit",
                slot: null,
            });
            return [2 /*return*/];
        });
    }); };
    var navigate = useNavigate();
    useEffect(function () {
        if (widgetModuleListFromLayoutState &&
            widgetModuleListFromLayoutState[module] &&
            !isDeleting) {
            setWidgetModuleListFromLayout(function (prev) {
                var incoming = widgetModuleListFromLayoutState[module] || [];
                var map = new Map();
                prev.forEach(function (w) { return map.set(w.id, w); });
                incoming.forEach(function (w) { return map.set(w.id, w); });
                return Array.from(map.values());
            });
        }
    }, [widgetModuleListFromLayoutState]);
    var saveWidgetList = function (publish) {
        if (publish === void 0) { publish = true; }
        return __awaiter(_this, void 0, void 0, function () {
            var content, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        content = widgetModuleListFromLayout;
                        return [4 /*yield*/, saveModuleBuilderLayoutListWidget({
                                moduleName: module,
                                params: {
                                    layout: fieldName,
                                },
                                body: {
                                    content: content,
                                },
                            }).unwrap()];
                    case 1:
                        response = _b.sent();
                        navigate("/modules/ModuleBuilder/".concat(type, "/packages/").concat(packagesName, "/").concat(module, "/layouts/").concat(fieldName));
                        toast.success("layout widget saved");
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        toast.error("Layout not saved");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var vue = fieldName.includes("list")
        ? t("app.LBL_LIST")
        : t("app.LBL_DETAILVIEW").toLowerCase();
    var widgetsSaved = (_b = list_widgetModule === null || list_widgetModule === void 0 ? void 0 : list_widgetModule.data) === null || _b === void 0 ? void 0 : _b.listwidgets;
    return (_jsx("div", __assign({ className: "flex w-full max-h-[50vh] overflow-y-auto" }, { children: _jsxs("div", __assign({ className: "w-full grid grid-cols-3 gap-4" }, { children: [_jsxs("div", __assign({ className: "col-span-1 shadow-md border p-5" }, { children: [_jsxs("label", __assign({ className: " ml-2 text-[rgb(var(--color-gray-400))]" }, { children: [t("app.LBL_ADD_WIDGET_LIST"), " ", moduleName, " ", vue] })), _jsx(WidgetSelectorStudio, { widget: selector })] })), _jsxs("div", __assign({ className: " col-span-2 border p-3 overflow-x-auto relative" }, { children: [_jsxs("label", __assign({ className: "text-[rgb(var(--color-gray-400))] " }, { children: [t("app.LBL_ADD_WIDGET_FOR"), " ", moduleName, " ", t("app.LBL_IN"), " ", vue, ":"] })), _jsx("hr", {}), _jsx("br", {}), widgetModuleListFromLayout.length > 0 || (widgetsSaved === null || widgetsSaved === void 0 ? void 0 : widgetsSaved.length) > 0 ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "flex w-full pr-5 overflow-auto" }, { children: widgetModuleListFromLayout === null || widgetModuleListFromLayout === void 0 ? void 0 : widgetModuleListFromLayout.map(function (widget) { return (_jsxs("div", __assign({ className: "w-full items-center mb-2 p-2" }, { children: [_jsxs("div", __assign({ className: "flex justify-end space-x-2 mb-1 w-full" }, { children: [_jsx("button", __assign({ onClick: function () { return handleEditWidget(widget); }, className: "group flex items-center justify-center w-8 h-8 rounded-full bg-green-50 hover:bg-green-100 transition-all duration-200 shadow-sm hover:shadow-md", title: "Edit" }, { children: _jsx(FontAwesomeIcon, { icon: faPencil, className: "text-green-600 group-hover:scale-110 transition-transform duration-200" }) })), _jsx("button", __assign({ onClick: function () { return handleRemoveWidget(widget.id); }, className: "group flex items-center justify-center w-8 h-8 rounded-full bg-red-50 hover:bg-red-100 transition-all duration-200 shadow-sm hover:shadow-md", title: "Delete" }, { children: _jsx(FontAwesomeIcon, { icon: faTrash, className: "text-red-600 group-hover:scale-110 transition-transform duration-200" }) }))] })), _jsx("div", __assign({ className: "w-full bg-[var(--colors-widget)] rounded-[var(--border-widget)] mt-[var(--margin-mt-widget)] mr-[var(--margin-mr-widget)] mb-[var(--margin-mb-widget)] ml-[var(--margin-ml-widget)]" }, { children: _jsx(WidgetDisplay, { widget: widget }, JSON.stringify(widget)) }))] }), widget.id)); }) })), _jsxs("button", __assign({ className: "button primary mt-[10px] flex items-center justify-center ", onClick: function () { return saveWidgetList(); } }, { children: [_jsx(FontAwesomeIcon, { icon: faSave, className: "px-1" }), t("app.LBL_SAVE_PUBLISH")] }))] })) : (_jsx("span", __assign({ className: " italic text-[--color-gray-400] " }, { children: t("app.LBL_EMPTY_LIST") }))), isLoadingSave && _jsx(LoaderImage, {})] }))] })) })));
}
